import script from "./Total.vue?vue&type=script&setup=true&lang=js"
export * from "./Total.vue?vue&type=script&setup=true&lang=js"

import "./Total.vue?vue&type=style&index=0&id=6c926169&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c926169"]])

export default __exports__